document.querySelectorAll('a[data-cta-type="js-form-popup"').forEach((element) => {
  element.addEventListener('click', function (event) {
    event.preventDefault();
    // event.stopPropagation();
    let target = this.getAttribute('data-cta-target');
    let popupOverlay = document.querySelector('#forms-overlay');
    popupOverlay.setAttribute('data-cta-target', target);
    document.querySelector(target).style.display = "flex";
    popupOverlay.style.display = "block";
    document.body.style.overflow = "hidden";
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('a[href="#coming-soon"]');
  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      let popupOverlay = document.querySelector('#forms-overlay');
      popupOverlay.setAttribute('data-cta-target', '#coming-soon-popup');
      document.querySelector('#coming-soon-popup').style.display = "flex";
      popupOverlay.style.display = "block";
      document.body.style.overflow = "hidden";
    });
  });
});

document.querySelectorAll('#black-overlay, .form-close').forEach((element) => {
  element.addEventListener('click', () => {
    let popupOverlay = document.querySelector('#forms-overlay');
    document.querySelectorAll('.form-popup').forEach((element) => {
      element.style.display = "none";
    });
    popupOverlay.style.display = "none";
    document.body.style.overflow = "auto";
  });
});

document.querySelectorAll('a[data-cta-type="js-whatsapp-open"]').forEach((element) => {
  element.addEventListener('click', function (event) {
    event.preventDefault();
    dfToggle();
  });
});


/* ===== SagePilot live chat (replaces Freshchat) =====
   The loader in layout/theme.liquid assigns window.sagepilotWidgetReady =
   window.ChatWidget.init(...), so we can wait for init() before calling open().
   Controls: ChatWidget.open() / .close() / .toggle() / .isOpen() */

function whenLiveChatReady(timeout) {
  const deadline = Date.now() + (timeout || 15000);
  return new Promise((resolve, reject) => {
    (function poll() {
      if (window.ChatWidget && typeof window.ChatWidget.open === 'function') {
        // Resolves immediately if init() returned a non-promise.
        return Promise.resolve(window.sagepilotWidgetReady).then(resolve, resolve);
      }
      if (Date.now() > deadline) return reject(new Error('SagePilot widget did not load'));
      setTimeout(poll, 50);
    })();
  });
}

function openLiveChat() {
  return whenLiveChatReady()
    .then(() => window.ChatWidget.open())
    .catch((error) => console.warn('[SagePilot]', error.message));
}

/* Aliases: openFreshChat is kept so any older inline snippet still works. */
window.openLiveChat = openLiveChat;
window.openFreshChat = openLiveChat;

/* Delegated click handler so CTAs injected after page load (menu drawer,
   mini-cart, section reloads) work too. "js-freshchat-open" is the legacy
   data-cta-type value still stored in section settings JSON — keep supporting
   it alongside the new "js-livechat-open". */
document.addEventListener('click', function (event) {
  const trigger = event.target.closest
    ? event.target.closest('[data-cta-type="js-freshchat-open"], [data-cta-type="js-livechat-open"]')
    : null;
  if (!trigger) return;

  event.preventDefault();

  /* Close the drawer the CTA sits in, otherwise it covers the chat panel.
     Handled by MenuDrawer/mini-cart via the bubbling drawer:force-close event. */
  trigger.dispatchEvent(new CustomEvent('drawer:force-close', { bubbles: true, cancelable: true, composed: true }));

  openLiveChat();
});

document.addEventListener('DOMContentLoaded', function () {

  /* Manage Quick Links */
  if (window.location.href.includes("/#callme")) {
    var callBackButton = document.querySelector('a[data-cta-type="js-form-popup"][data-cta-target="#callmeback-popup"]');
    if (callBackButton) {
      callBackButton.click();
    }
  } else if (window.location.href.includes("#livechat")) {
    openLiveChat();
  } else if (window.location.href.includes("/#cart")) {
    var cartButton = document.querySelector('#cart-icon-bubble');
    if (cartButton) {
      cartButton.click();
    }
  } else if (window.location.href.includes("/#submit-review")) {
    let popupOverlay = document.querySelector('#forms-overlay');
    popupOverlay.setAttribute('data-cta-target', '#form-submit-review-popup');
    document.querySelector('#submit-review-popup').style.display = "flex";
    popupOverlay.style.display = "block";
    document.body.style.overflow = "hidden";
  }

  const kwesForms = document.querySelectorAll('.kwes-form');

  function kwesFormEventListener(event) {
    const form = event.target;
    const elements = form.querySelectorAll('.form-element');
    elements.forEach(function (element) {
      element.style.display = 'none';
    });
  }

  kwesForms.forEach(function (form) {
    form.addEventListener('kwSubmitted', kwesFormEventListener);
  });

});